import React, { Component } from 'react';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import {actionsStyles} from '../../assests/styles/DataTableStyle';
import { withStyles } from '@material-ui/core/styles';

class Pagination extends Component {
    handleFirstPageButtonClick = () => {
      this.props.onPageChange(0);
    };
  
    handleBackButtonClick = () => {
      this.props.onPageChange(this.props.page - 1);
    };
  
    fetchMore = (event)=>{
        this.props.onPageChange(event);
 
    }
    handleNextButtonClick = () => {
      this.props.onPageChange(this.props.page + 1);
    };
  
    handleLastPageButtonClick = () => {
      this.props.onPageChange(
        Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
      );
    };
  


    render() {

          const { classes, count, page, rowsPerPage, theme } = this.props;
          
      return (
        <div className={classes.root}>
          <IconButton className={classes.iconButton} 
            onClick={this.handleFirstPageButtonClick}
            disabled={page === 0}
            aria-label="First Page"
          >
            {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
          </IconButton>
          <IconButton className={classes.iconButton} 
            onClick={this.handleBackButtonClick}
            disabled={page === 0}
            aria-label="Previous Page"
          >
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
          </IconButton>
          <IconButton className={classes.iconButton} 
            onClick={this.handleNextButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="Next Page"
          >
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </IconButton>
          <IconButton className={classes.iconButton} 
            onClick={this.handleLastPageButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage) - 1}
            aria-label="Last Page"
          >
            {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
          </IconButton>

          {/* <IconButton className={classes.iconButton} 
            onClick={this.fetchMore}
            disabled={sessionStorage.getItem('backIconButtonProps')=== 'undefined'
                || (page < Math.ceil(count / rowsPerPage) - 1 || 
              'false' === sessionStorage.getItem('backIconButtonProps')) }
            aria-label="Last Page"
          >
            {theme.direction === 'rtl' ? null : <i class='fa fa-angle-double-right' tooltip ="fetch more"></i>}
          </IconButton> */}
        </div>
      );
    }
  }
  

  export default withStyles(actionsStyles, { withTheme: true })(
    Pagination,
  );
  
  